import {useState} from "react";
import type {DungeonLevel} from "@/dungeons/model/DungeonLevel.ts";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {gridToWorld} from "@/dungeons/geometry/Coordinates.ts";
import {transitionAreaCenter} from "@/dungeons/geometry/TransitionPolygon.ts";
import {transitionArrivalWorld} from "@/dungeons/geometry/TransitionArrival.ts";

export function useTransitionPreview(activeLevel?: DungeonLevel) {
    const {dungeon} = useDungeon();
    const [hoveredTransitionId, setHoveredTransitionId] = useState<string>();
    const transition = activeLevel?.geometry.transitions.find(item => item.id === hoveredTransitionId);
    const targetLevel = dungeon.levels.find(level => level.id === transition?.targetLevelId);
    return {
        setHoveredTransitionId, targetLevel,
        arrivalPreview: transition && targetLevel ? transitionArrivalWorld(transition, targetLevel.geometry) : undefined,
        transitionCenter: transition && activeLevel ? gridToWorld(transitionAreaCenter(transition.points), activeLevel.geometry.grid) : undefined,
    };
}
